export default __webpack_public_path__ + "static/media/no_image_logo.95ba2e63.png";